import { Injectable } from '@angular/core';
import { BrowserNavigationService } from './browser-navigation.service';
import { InAppBrowserService } from '../in-app-browser.service';


@Injectable()
export class NativeBrowserNavigationService extends BrowserNavigationService {
  constructor(private readonly inAppBrowser: InAppBrowserService) {
    super();
  }

  open(url: string): void {
    this.inAppBrowser.openExternalBrowser(url);
  }
}
